import { useQuery, useMutation } from "react-query";
import * as api from "api/Api"

export const useGetUtama = () => {
    return useQuery(["GetUtama"], () => api.getUtama());
};

// list
export const useEmployeeList = () => {
    return useMutation(employeeListRequest, {
        onSuccess: (data) => {
        },
    });
};
const employeeListRequest = async (data) => {
    return api.employeeListRequest(data)
}

export const useRoles = () => {
    return useQuery(["Roles"], () => api.getRoles());
};

export const useRegisterStaff = () => {
    return useMutation(registerStaffRequest, {
        onSuccess: (data) => {
            // setAuth(data.data);
            // history.replace('/')
            <><div>Test return</div></>
        },
    });
};
const registerStaffRequest = async (credential) => {
    return api.registerStaffRequest(credential)
}

// list
export const useRoleList = () => {
    return useMutation(roleListRequest, {
        onSuccess: (data) => {
        },
    });
};
const roleListRequest = async (data) => {
    return api.roleListRequest(data)
}

export const useRegisterRole = () => {
    return useMutation(registerRoleRequest, {
        onSuccess: (data) => {
            // setAuth(data.data);
            // history.replace('/')
            <><div>Test return</div></>
        },
    });
};
const registerRoleRequest = async (credential) => {
    return api.registerRoleRequest(credential)
}